import { Contract } from "@definitions/types/symfonyTypes"

/** Contract is shown only when validFrom is absent or current date is on or after it and validUntil is absent or current date is before it or equal to it. */
export function isContractValid(contract: Contract): boolean {
  const { validFrom, validUntil } = contract
  const now = new Date()

  if (validFrom) {
    const validFromDate = new Date(validFrom)
    if (Number.isNaN(validFromDate.getTime())) return false
    if (now < validFromDate) return false
  }

  if (validUntil) {
    const validUntilDate = new Date(validUntil)
    if (!Number.isNaN(validUntilDate.getTime()) && now >= validUntilDate) return false
  }

  return true
}